import React from 'react';
import { Modal } from '@duxton-web/ui';
import scribe from '@grab-x/scribe-web-sdk';

import { AbortPrompt } from '@/common/AbortPrompt';
import PausePrompt from '@/common/PausePrompt/PausePrompt';
import RejectPrompt from '@/common/RejectPrompt/RejectPrompt';
import { scribeInstrumentationEvents } from '@/common/Scribe/EventsList';
import { ADAPTIVE } from '@/constants';
import { AdaptiveExperiment, Experiment } from '@/lib/App';

interface ExperimentsModalsProps {
  openPauseModal: boolean;
  openRejectModal: boolean;
  openAbortModal: boolean;
  experiment: Experiment | null;
  adaptiveExperiment: AdaptiveExperiment | null;
  experimentType: string;
  onClosePause: () => void;
  onCloseReject: () => void;
  onCloseAbort: () => void;
  onSuccess: () => void;
}

const ExperimentsModals: React.FC<ExperimentsModalsProps> = ({
  openPauseModal,
  openRejectModal,
  openAbortModal,
  experiment,
  adaptiveExperiment,
  experimentType,
  onClosePause,
  onCloseReject,
  onCloseAbort,
  onSuccess,
}) => {
  const experimentName = experiment?.name || adaptiveExperiment?.name;
  const isAdaptive = experimentType === ADAPTIVE;

  return (
    <>
      {openPauseModal && (
        <Modal
          title="Do you want to pause this experiment?"
          open={openPauseModal}
          onCancel={onClosePause}
          footer={null}
        >
          <PausePrompt
            experiment={experimentName}
            isAdaptiveExp={isAdaptive}
            onSuccess={() => {
              scribe.sendEvent(
                scribeInstrumentationEvents.clickPauseExperiment.name,
                {
                  experiment: experiment?.name,
                  status: experiment?.state,
                  STATE_NAME:
                    scribeInstrumentationEvents.clickPauseExperiment.state,
                },
              );
              onClosePause();
              onSuccess();
            }}
            layout="vertical"
          />
        </Modal>
      )}

      {openRejectModal && (
        <Modal
          title="Do you want to reject this experiment?"
          open={openRejectModal}
          onCancel={onCloseReject}
          footer={null}
        >
          <RejectPrompt
            experiment={experimentName}
            isAdaptiveExp={isAdaptive}
            onSuccess={() => {
              scribe.sendEvent(
                scribeInstrumentationEvents.clickRejectExperiment.name,
                {
                  experiment: experiment?.name,
                  status: experiment?.state,
                  STATE_NAME:
                    scribeInstrumentationEvents.clickRejectExperiment.state,
                },
              );
              onCloseReject();
              onSuccess();
            }}
            layout="vertical"
          />
        </Modal>
      )}

      <Modal
        title="Do you want to abort this experiment?"
        open={openAbortModal}
        onCancel={onCloseAbort}
        footer={null}
      >
        <AbortPrompt
          experiment={experimentName}
          isAdaptiveExp={isAdaptive}
          onSuccess={() => {
            scribe.sendEvent(
              scribeInstrumentationEvents.clickAbortExperiment.name,
              {
                experiment: experiment?.name,
                status: experiment?.state,
                STATE_NAME:
                  scribeInstrumentationEvents.clickAbortExperiment.state,
              },
            );
            onCloseAbort();
            onSuccess();
          }}
          layout="vertical"
        />
      </Modal>
    </>
  );
};

export default ExperimentsModals;
